var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6479 2.31621L6.38889 9.64925C6.15901 9.88161 5.8566 10.0071 5.54493 9.99969C5.23323 9.9921 4.93611 9.85238 4.71575 9.6093L1.08627 5.60935C0.852746 5.36092 0.719679 5.01965 0.716843 4.66205C0.714008 4.30425 0.841812 3.96052 1.07108 3.70761C1.30056 3.45471 1.61265 3.31409 1.93713 3.31699C2.26159 3.32012 2.57145 3.46677 2.7969 3.72413L5.60731 6.8214L12.0123 0.350636C12.3309 0.0287661 12.7809 -0.0815005 13.1933 0.0615774C13.6056 0.204432 13.9174 0.578981 14.0111 1.04413C14.1049 1.50908 13.9662 1.9941 13.6479 2.31621Z",
    fill: "#6AA13C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.eb50ce40f356c1b780cf7134ae639cd0.svg";
export { ForwardRef as ReactComponent };